export enum TopListShortcutNames {
  TODAY = 'Today',
  YESTERDAY = 'Yesterday',
  LAST_SEVEN_DAYS = 'Last 7 days',
  THIS_MONTH = 'This month',
}
